import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";





import './App.css';
import logo1 from './assets/logo1.jpg';
import hero from './assets/hero.jpg';
import directeur from './assets/directeur.jpg';
import cat1 from './assets/cat1.jpg';  
import cat2 from './assets/cat2.jpg';
import cat3 from './assets/cat3.jpg';
import cat4 from './assets/cat4.jpg';
import cat5 from './assets/cat5.jpg';
import cat6 from './assets/cat6.jpg';
import cat7 from './assets/cat7.jpg';
import fus1 from './assets/fus1.jpg';
import fus2 from './assets/fus2.jpg';
import fus3 from './assets/fus3.jpg';



function Home() {
  // Gestion des états pour les cartes
  const [currentIndex, setCurrentIndex] = useState(0);
  const cards = [
    "Professionele schoonmaak van trappenhuizen",
    "Schoonmaak van kantoren",
    "Professioneel schoonmaakonderhoud",
    "Glazenwasservice",
    // "Nettoyage et entretien des porches pour VVE",
    "Specialistische reiniging",
    "Reiniging van bouwprojecten"
  ];

  // Les images des cartes
  const cardImages = [
    cat1, // Image pour "Nettoyage des cages d'escalier"
    cat2, // Image pour "Bureaux de nettoyage"
    cat3, // Image pour "Entretien de nettoyage"
    cat4, // Image pour "Nettoyeur de vitres à Utrecht"
    cat5, // Image pour "Nettoyage et entretien des porches pour VVE"
    cat6, // Image pour "Nettoyage spécialisé"
    cat7  // Image pour "Nettoyage de chantier"
  ];

  // Fonction pour changer les cartes
  const changeCard = (direction) => {
    const totalCards = cards.length;
    let nextIndex = currentIndex + direction;
    
    // Vérifier que l'index ne dépasse pas les limites
    if (nextIndex < 0) {
      nextIndex = totalCards - 3; // revenir à la dernière carte (3 cartes visibles)
    }
    if (nextIndex >= totalCards - 2) {
      nextIndex = 0; // revenir à la première carte
    }

    setCurrentIndex(nextIndex);
  };

  // Effect pour changer les cartes automatiquement toutes les 3 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      changeCard(1);  // change la carte toutes les 3 secondes
    }, 3000); // 3000 ms = 3 secondes

    // Nettoyer l'intervalle lorsque le composant est démonté
    return () => clearInterval(interval);
  }, [currentIndex]);  // Effect se déclenche chaque fois que `currentIndex` change

  return (
    <div className="App">
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(0,123,193,0.85) 0%, rgba(0,199,190,0.65) 60%), url(${hero})`
        }}
      >
        {/* === HEADER === */}
        <Header /> 
        

        {/* === CONTENU HERO (Texte + Formulaire) === */}
        <div className="hero-content">
          {/* Colonne gauche */}
          <div className="hero-left">
            <h1>Gespecialiseerde schoonmaakdienst voor elke omgeving</h1>
            <h3 className="subtitle">
              Efficiëntie, kwaliteit en eerlijke prijzen
            </h3>

            <p className="hero-text">
              Zoekt u een schoonmaakbedrijf dat efficiënt werkt en aandacht heeft voor uw wensen?
              DirectSchoon Cleaning Services staat klaar voor particulieren en bedrijven in de hele regio.
            </p>

            <div className="hero-buttons">
              <Link to="/entreprises" className="btn btn-primary">
                Schoonmaakdiensten voor bedrijven
              </Link>

              <button className="btn btn-secondary">Thuis­schoonmaak op maat</button>
            </div>
          </div>

          {/* Colonne droite - Formulaire */}
          <div className="hero-form">
            <h2>
              Meer weten? Neem contact op via 06 41 41 61 69 of stel uw vraag hieronder.
            </h2>

            <form>
              <div className="form-row">
                <div>
                  <label>Voornaam</label>
                  <input type="text" placeholder="Voornaam" />
                </div>
                <div>
                  <label>Achternaam</label>
                  <input type="text" placeholder="Achternaam" />
                </div>
              </div>

              <div>
                <label>E-mail <span>*</span></label>
                <input type="email" placeholder="E-mail" required />
              </div>

              <div>
                <label>Wat is uw vraag?</label>
                <textarea rows="4" placeholder=""></textarea>
              </div>

              <button type="submit" className="btn-submit">Verzenden</button>
            </form>
          </div>
        </div>
      </section>

      {/* === Section Pourquoi Brom === */}
      <section className="why-brom">
        <h2>Waroom DirectSchoon ?</h2>
        <p>
          DirectSchoon Cleaning Company staat bekend om snelle service en hoogwaardige kwaliteit aan competitieve tarieven.
          Klanten kiezen ons omdat we efficiënt en nauwkeurig werken.
        </p>
        <div className="why-brom-cards">
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Transparante afspraken en transparante communicatie</p>
          </div>
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Snel en van hoge kwaliteit</p>
          </div>
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Zorg voor mensen en voor het milieu</p>
          </div>
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Scherpe prijzen door efficiënt werken</p>
          </div>
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Ervaren & gecertificeerd team</p>
          </div>
          <div className="card">
            <i className="fas fa-check-circle"></i>
            <p>Professioneel team met Nederlands- en Engelstalige medewerkers</p>
          </div>
        </div>
      </section>

      {/* Section Entreprise Familiale */}
      {/* <div className="company-section">
        <div className="company-image">
          <img src={directeur} alt="Directeur Brom" />
        </div>
        <div className="company-right">
          <h2 className="company-title">Entreprise familiale depuis 1990</h2>
          <p className="company-subtitle">Des employés motivés et qualifiés</p>
          <p className="company-description">
            Ali Brom est le fondateur de Brom Cleaning Company. Il a débuté modestement en 1990. Grâce à son travail acharné, son dévouement et sa passion pour son métier, l'entreprise est devenue une PME. Ce succès est dû en partie à une équipe nombreuse et motivée. Outre son activité professionnelle intense, il apprécie de s'impliquer dans des projets communautaires.
          </p>
          <button className="learn-more-btn">En savoir plus</button>
        </div>
      </div> */}

      {/* Section des services de nettoyage */}
      <div className="service-section">
        <h2 className="service-title">De perfecte oplossing voor elke schoonmaaktaak</h2>
        <h3 className="service-subtitle">Uitgebreide en professionele schoonmaakdiensten</h3>
        <p className="service-description">
          Onze diensten omvatten een volledig en professioneel schoonmaakaanbod: onderhoud, glasbewassing en gespecialiseerde reiniging voor kantoren, woningen, gebouwen en uiteenlopende eigendommen. Gecertificeerd schoonmaakbedrijf verzorgen wij het onderhoud van kantoren, winkels, VvE’s, scholen, onderwijsinstellingen, medische praktijken, crèches en bouwprojecten.
        </p>
        <div className="button-group">
          <button className="service-btn commercial-btn">Zakeljik</button>
          <button className="service-btn prive-btn">Particulier</button>
        </div>
      </div>

      {/* Section du Catalogue */}
      <div className="catalogue-section">
        <div className="catalogue-container">
          {cards.slice(currentIndex, currentIndex + 3).map((card, index) => (
            <div className="catalogue-card" key={index}>
              {card === "Professionele schoonmaak van trappenhuizen" && (
                <img src={cat1} alt="Professionele schoonmaak van trappenhuizen" className="catalogue-card-image" />
              )}
              {card === "Schoonmaak van kantoren" && (
                <img src={cat2} alt="Schoonmaak van kantoren" className="catalogue-card-image" />
              )}
              {card === "Professioneel schoonmaakonderhoud" && (
                <img src={cat3} alt="Professioneel schoonmaakonderhoud" className="catalogue-card-image" />
              )}
              {card === "Glazenwasservice" && (
                <img src={cat4} alt="Glazenwasservice" className="catalogue-card-image" />
              )}
              {/* {card === "Nettoyage et entretien des porches pour VVE" && (
                <img src={cat5} alt="Nettoyage et entretien des porches pour VVE" className="catalogue-card-image" />
              )} */}
              {card === "Specialistische reiniging" && (
                <img src={cat6} alt="Specialistische reiniging" className="catalogue-card-image" />
              )}
              {card === "Reiniging van bouwprojecten" && (
                <img src={cat7} alt="Reiniging van bouwprojecten" className="catalogue-card-image" />
              )}
              <h3>{card}</h3>
              <button className="en-savoir-plus">Meer weten</button>
            </div>
          ))}
        </div>

        {/* Flèches de navigation */}
        <div className="catalogue-nav">
          <button className="arrow-left" onClick={() => changeCard(-1)}>&#8249;</button>
          <button className="arrow-right" onClick={() => changeCard(1)}>&#8250;</button>
        </div>

        {/* Bouton "Tous les services aux entreprises" */}
        <div className="catalogue-footer">
          <button className="all-services-btn">Bedrijfsdiensten</button>
        </div>
      </div>



      {/* === SECTION FUSION IMAGE + TEXTE === */}
      <div className="flexible-section">

        {/* Colonne gauche : les deux images */}
        <div className="flexible-images">
          <img src={fus2} alt="Service 2" className="fus fus-top" />
          <img src={fus1} alt="Service 1" className="fus fus-bottom" />
        </div>

        {/* Colonne droite : texte + bouton */}
        <div className="flexible-text">
          <h2>Flexibel en volledig afgestemd op uw specifieke schoonmaakbehoeften</h2>

          <p>
            Of u nu dagelijkse, wekelijkse of periodieke schoonmaak wenst, wij werken flexibel en stemmen ons volledig af op uw wensen en verwachtingen.
          </p>

          <p>
            Tijdens een eerste kennismaking brengen wij uw schoonmaakbehoeften in kaart en organiseren wij alles volgens uw situatie. Vervolgens ontvangt u binnen twee werkdagen een gratis en vrijblijvende offerte.
          </p>

          <p>
            Daarnaast voorzien wij alle benodigde sanitaire artikelen: toiletpapier, handzeep, dispensers, handdoeken en desinfectiemiddelen — voor een frisse, hygiënische en veilige sanitaire ervaring.
          </p>

          <button className="flexible-btn">Bedrijfsdiensten</button>
        </div>
      </div>

      {/* === SECTION TARIFS (Dégradé bleu) === */}
      {/* === SECTION TARIFS (Dégradé bleu) === */}
      <section className="pricing-section">
        <div className="pricing-content">
          <div className="pricing-left">
            <h2>Transparante, betaalbare en concurrerende tarieven</h2>

            <p>
              Onze efficiënte werkwijze, nauwkeurige tijdsopvolging en doordacht aankoopbeleid stellen ons in staat om scherpe en aantrekkelijke prijzen te garanderen. Zo behalen wij vrijwel altijd optimale resultaten zonder uw budget te overschrijden.
            </p>
          </div>

          <div className="pricing-right">
            <button className="pricing-btn">Meer weten</button>
            {/* <a href="#" className="pricing-link">Ou demandez un devis directement</a> */}
          </div>
        </div>

        {/* image bg */}
        <img src={fus3} alt="background" className="pricing-bg" />

        {/* étoiles */}
        <div className="stars">✨ ✨ ✨</div>
      </section>


      {/* === FOOTER SIMPLE RECTANGLE BLEU === */}
      {/* === FOOTER RECTANGLE BLEU === */}
      <Footer />




    </div>
  );
}

export default Home;
